import { isLocalUrl, getLinkTargetAttr } from './../utils/handleAttributes';

export default function customTicketButton() {
  const widgetName = 'customTicketButton';
  const widgetOpts = customTicketButtonOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomBtn(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomBtn(widgetData) {
    const { Title, URL } = widgetData.items[0];

    if (URL == null) {
      $widget.remove();
    } else {
      const isLocal = isLocalUrl(URL);
      const targetElement = getLinkTargetAttr(isLocal);
      $widget
        .find('.card-widget-item')
        .replaceWith(
          `<a class="button ${widgetName}" tabindex="0" href="${URL}" ${targetElement}>${Title}</a>`,
        );
    }
  }
}
